export default __webpack_public_path__ + "static/media/b2.ed3d8717.jpg";